import { useEffect, useState } from 'react'
import { X, Loader2 } from 'lucide-react'

interface Props {
  /** URL pełnego obrazka. Może być `null` gdy URL jest jeszcze pobierany - wtedy lightbox
   *  pokazuje spinner. Pozwala otworzyć lightbox NATYCHMIAST po kliknięciu, fetch URL leci
   *  w tle. */
  src: string | null
  filename?: string
  onClose: () => void
}

/** Pełnoekranowy podgląd obrazka z loaderem. Esc / klik tła / X zamyka. */
export function ImageLightbox({ src, filename, onClose }: Props) {
  const [imgLoaded, setImgLoaded] = useState(false)

  useEffect(() => {
    setImgLoaded(false)  // reset przy zmianie src (np. przejście null -> URL)
  }, [src])

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  const showSpinner = !src || !imgLoaded

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClose() }}
        className="absolute right-4 top-4 flex size-9 items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20"
        title="Zamknij (Esc)"
      >
        <X size={18} />
      </button>

      {showSpinner && (
        <Loader2 className="absolute size-10 animate-spin text-white/70" />
      )}

      {src && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="flex max-h-[90vh] max-w-[90vw] flex-col items-center gap-2"
        >
          <img
            src={src}
            alt={filename ?? ''}
            onLoad={() => setImgLoaded(true)}
            className={`max-h-[80vh] max-w-full rounded object-contain shadow-2xl transition-opacity duration-150 ${
              imgLoaded ? 'opacity-100' : 'opacity-0'
            }`}
          />
          {filename && imgLoaded && (
            <div className="rounded bg-black/40 px-3 py-1 text-xs text-white/80">
              {filename}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
